import { isEqual, cloneDeep } from "lodash";

export const AD_CACHE_MINUTES: number = 10;
export const AD_CACHE_KEY: string = "provi-cached-ads";
export enum AdTypes {
  Product = "product",
  ProductIndexBanner = "product_index_banner",
  ShoppableUnit = "shoppable_unit",
}

const requestFiltersToCache = (requestFilters): any => {
  const clonedFilters = cloneDeep(requestFilters);
  delete clonedFilters.page; // Do not store page number in cache.

  return clonedFilters;
};

const getCachedAdsForType = (adType: string): any => {
  const allCachedAds: any = JSON.parse(sessionStorage.getItem(AD_CACHE_KEY)) || {};
  return allCachedAds[adType];
};

const cachedAdsAreValid = (adType: string, requestFilters: any): boolean => {
  const cachedAds: any = getCachedAdsForType(adType);
  const adsPresent: boolean = cachedAds?.adData.length > 0;
  const filtersMatch: boolean = isEqual(
    cachedAds?.requestFilters,
    requestFiltersToCache(requestFilters),
  );
  const adsHaveNotExpired: boolean = new Date().getTime() <= cachedAds?.expiresAt;

  return adsPresent && filtersMatch && adsHaveNotExpired;
};

const newExpirationDate = (): number => {
  return new Date().getTime() + AD_CACHE_MINUTES * 60 * 1000;
};

export const storeCachedAds = (
  adType: string,
  adData: any = [],
  requestFilters: any = {},
  expiresAt: number = null,
) => {
  const allCachedAds: any = JSON.parse(sessionStorage.getItem(AD_CACHE_KEY)) || {};

  if (adData?.length) {
    allCachedAds[adType] = {
      adData,
      requestFilters: requestFiltersToCache(requestFilters),
      expiresAt: expiresAt || newExpirationDate(),
    };
  } else {
    delete allCachedAds[adType];
  }

  sessionStorage.setItem(AD_CACHE_KEY, JSON.stringify(allCachedAds));
};

const clearCachedAds = (adType: string) => {
  storeCachedAds(adType); // Not having adData will cause the ad type to be deleted from cache.
};

export const getCachedAds = (adType: string, requestFilters: any, numberOfAds: number): any => {
  if (cachedAdsAreValid(adType, requestFilters)) {
    const cachedAds: any = getCachedAdsForType(adType);
    const adsToReturn: any = cachedAds.adData.slice(0, numberOfAds);
    const remainingAds: any = cachedAds.adData.slice(numberOfAds);

    storeCachedAds(adType, remainingAds, requestFilters, cachedAds.expiresAt);
    return adsToReturn;
  } else {
    clearCachedAds(adType);
    return [];
  }
};
